<template>
</template>
<script setup lang="ts">

import {useBus} from "@/core/store/bus";
import {RouteLocationRaw, useRouter} from "vue-router";

const {bus} = useBus()
const router = useRouter()

const prepareRouterTo = (to: RouteLocationRaw) => {
  if (typeof to === 'string') {
    to = {
      path: to,
    }
  }
  to = {
    ...to,
    force: true
  }
  return to;
}

bus.on('router:push', (to: RouteLocationRaw) => {
  router.push(prepareRouterTo(to))
})
bus.on('router:replace', (to: RouteLocationRaw) => {
  router.replace(prepareRouterTo(to))
})

</script>
